import React from 'react';
import PropTypes from 'prop-types';

const TeeTimesWidgetBar = (
    {
        search,
        selectedRoundId,
        title
    }
) => {
    const stateCss = search.isPredictive ? 'is-predictive' : '';
    const updatedTitle = title.replace('{roundNumber}', selectedRoundId);

    return (
        <div className={`tee-times-widget-bar ${stateCss}`}>
            <div className="tee-times-widget-bar__header">
                <div className="tee-times-widget-bar__left-line">
                    <div className="tee-times-widget-bar__title">
                        {updatedTitle}
                    </div>
                </div>
            </div>
        </div>
    );
};

TeeTimesWidgetBar.propTypes = {
    choices: PropTypes.array,
    nextOutDate: PropTypes.string,
    setRound: PropTypes.func,
    reverseOrder: PropTypes.func.isRequired,
    showNextOut: PropTypes.func.isRequired,
    toggleFavourites: PropTypes.func.isRequired
};

export default TeeTimesWidgetBar;
